import axios from 'axios'
import contentful from 'contentful'
import EventBus from '@/eventbus'

import Firebase from 'firebase'
import firebase from 'firebase/app'
import Utility from '@/utility'


let host = window.location.host.split('.')[0]
// let apiTest = false
let bypassCacheParam = ''

const stanwoodUrlDevelop = 'https://bw-football-contentful-dev.appspot.com/'
const stanwoodUrlProduction = 'https://bw-football-contentful.appspot.com/'
const spacesDevelop = 'in1ws0j2cnhw'
const spacesProduction = '1mgney1of7oi'
const accessTokenDevelop = 'a679712c0a5df3e639063cc9e90b17ba409a064d22920319b4b256977010e620'
const accessTokenProduction = 'c9548fa3330918f7aa5fed3e8efe2904dc53db9c479d3a98cd0e340d6c62333f'
const firebaseConfigDevelop = {
  apiKey: "AIzaSyCx_6aQm5xhXHiAhFdrmaefw4mFpQlLS60",
  authDomain: "wfv-cms-develop.firebaseapp.com",
  databaseURL: "https://wfv-cms-develop.firebaseio.com",
  projectId: "wfv-cms-develop",
  storageBucket: "wfv-cms-develop.appspot.com",
  messagingSenderId: "6981202812"
}
const firebaseConfigProduction = {
  apiKey: "AIzaSyBYhlqdcQpIqLargbODZmqnisgLQrmpXVc",
  authDomain: "wfv-cms.firebaseapp.com",
  databaseURL: "https://wfv-cms.firebaseio.com",
  projectId: "wfv-cms",
  storageBucket: "wfv-cms.appspot.com",
  messagingSenderId: "141416234892"
}

let stanwoodUrl = ''
let spaces = ''
let accessToken =''
let firebaseConfig = ''

// Set databases
let db = localStorage.getItem('wfv_db_fe')
// console.log('db: ', db)

if (db === 'production') {
  stanwoodUrl = stanwoodUrlProduction
  bypassCacheParam = `&${Date.now()}`
  spaces = spacesProduction
  accessToken = accessTokenProduction
  firebaseConfig = firebaseConfigProduction
} else {
  stanwoodUrl = (host.indexOf('localhost') >= 0 || host.indexOf('develop') >= 0) ? stanwoodUrlDevelop : stanwoodUrlProduction
  spaces = (host.indexOf('localhost') >= 0 || host.indexOf('develop') >= 0) ? spacesDevelop : spacesProduction
  accessToken = (host.indexOf('localhost') >= 0 || host.indexOf('develop') >= 0) ? accessTokenDevelop : accessTokenProduction
  firebaseConfig = (host.indexOf('localhost') >= 0 || host.indexOf('develop') >= 0) ? firebaseConfigDevelop : firebaseConfigProduction
}

const cdnUrl = 'https://cdn.contentful.com/spaces/'
const cdnQuery = '/entries/?access_token='

const content_management_api_key = '88fff7c07ac417159a61ccfcef167584e10060b418a433f4679b85a20b608805'
const baseContentfulNavigationId = '4pvrw097EAeGAA2ey6Cu4Y'
const baseContentfulRegionId = 'N5AHhBII6a8USMAGkwGk8'
const baseUrl = cdnUrl + spaces +cdnQuery + accessToken

const baseEntryUrl = stanwoodUrl + 'contentful/entries'
const baseAssetUrl = stanwoodUrl + 'contentful/assets'
const baseAssetDownloadUrl = stanwoodUrl + 'contentful/download/'
const baseManageUrl = stanwoodUrl +  'manage/contentful/'
const baseSearchUrl = stanwoodUrl +  'contentful/'

const firebaseLogin = 'valerio.pisapia@stanwood.de'
const firebasePassword = '123456'

const client = contentful.createClient({
  space: spaces,
  accessToken: accessToken,
})

const contentfulManagement = require('contentful-management');
const client2 = contentfulManagement.createClient({
  accessToken: content_management_api_key
})

let keyLastReadArticles = 'last_read_articles'

export default {
  // Load Asset
  loadAsset (id) {
    return client.getAsset(id)
  },

  // Load all regions
  loadAllRegions () {
    let url = `${baseEntryUrl}?content_type=region${bypassCacheParam}`
    return axios.get(url)
  },

  // Get region ID
  getRegionId (region) {
    if (!region || (region === '/verband') || (region === 'verband')) {
      region = '/'
    } else {
      region = region.replace(/\//g,'')
      region = `/${region}`
    }

    let regionUrl = `${baseEntryUrl}?content_type=region&include=5&fields.path=${region}${bypassCacheParam}`

    // GET region
    let res = axios.get(regionUrl)
    return res

  },

  // Load navigation items
  loadNavigationNew (region) {

    let sysId = ''
    return this.getRegionId(region)
      .then((response) => {
        if (response.data.items[0].sys.hasOwnProperty('id')) {
          sysId = response.data.items[0].sys.id

          let navigationUrl = `${baseEntryUrl}?content_type=navigation&include=5&fields.region.sys.id=${sysId}${bypassCacheParam}`

          // GET navigation items
          return axios.get(navigationUrl)
        }
      })
      .catch((error) => {
        this.errorHandling(error, 'api.js -> loadNavigationNew - region id')
      })
  },

  // Load navigation items
  loadNavigation (region) {
    region = (!!region) ? region : 'Landesverband'   //TODO: It is a workaround since the region should be always available.
    region = region.charAt(0).toUpperCase() + region.slice(1)

    let url = `${baseEntryUrl}?content_type=navigation&fields.title=${region}${bypassCacheParam}`

    return axios.get(url).then(data => {
      let naviUrl = `${baseEntryUrl}?sys.id=${data.data.items[0].sys.id}&include=5${bypassCacheParam}`

      return axios.get(naviUrl)
    }).catch((error) => {
      this.errorHandling(error, 'api.js -> loadNavigation')
    })
  },

  checkErrorItems (errors, sysId) {
    if (errors) {
      return errors.map((error) => {
        let res = false
        let errorId = ''

        if (error.details.id === sysId) {
          res = true
          errorId = error.details.id
        }

        return res;
      })
    } else {
      return false
    }
  },

  // Load articles of first page in navigation
  getMainArticlesNew (region = '') {
    let sysId = ''

    return this.getRegionId(region)
      .then((response) => {
        sysId = response.data.items[0].sys.id
        // console.log('response: ', sysId)

        let navigationUrl = `${baseEntryUrl}?content_type=navigation&include=5&fields.region.sys.id=${sysId}${bypassCacheParam}`

        // GET navigation items
        return axios.get(navigationUrl).then(data => {
          let items = data.data.items[0].fields.navigationItems
          let errors = data.data.errors
          let pageId = ''
          let checkError = false
          let newItems = []

          // get all items
          if (items) {
            items.map((item) => {
              checkError = this.checkErrorItems(errors, item.sys.id)

              if(!checkError[0]) {
                pageId = item.sys.id
                newItems.push(pageId)
              }
            })
          }

          pageId = newItems[0]

          let artUrl = `${baseEntryUrl}?content_type=page&fields.region.sys.id=${sysId}&fields.navigationItem.sys.id=${pageId}${bypassCacheParam}`

          return axios.get(artUrl)
        }).catch((error) => {
          this.errorHandling(error, 'api.js -> getMainArticlesNew')
        })
      })
      .catch((error) => {
        this.errorHandling(error, 'api.js -> getMainArticlesNew - region id')
      })
  },

  // get fallback background image
  getBackgroundImageFallback (bgId) {

      let bgUrl = `${baseEntryUrl}?content_type=page&include=5&limit=1&fields.navigationItem.sys.id=${bgId}${bypassCacheParam}`

      return axios.get(bgUrl)
  },

  // get background image
  getBackgroundImageNew (bgId) {

      let bgUrl = `${baseAssetUrl}?include=5&limit=1&sys.id=${bgId}${bypassCacheParam}`

      return axios.get(bgUrl)
  },

  // Load articles of first page in navigation
  getMainArticles (region = '', idNavigation = baseContentfulNavigationId) {

    if(region) {
      idNavigation = ''
    } else {
      region = ''
    }

    let url = `${baseEntryUrl}?content_type=navigation&include=5&fields.title=${region}&sys.id=${idNavigation}${bypassCacheParam}`

    return axios.get(url).then(data => {
      let pageId = data.data.items[0].fields.navigationItems[0].sys.id
      let artUrl = `${baseEntryUrl}?include=5&limit=1&content_type=page&fields.navigationItem.sys.id=${pageId}${bypassCacheParam}`

      return axios.get(artUrl)
    }).catch((error) => {
      this.errorHandling(error, 'api.js -> getMainArticles')
    })
  },

  // Load articles that include the shipped keyword
  getArticlesFromKeyword (keyword) {
    let url = `${baseEntryUrl}?content_type=article&order=-sys.createdAt&fields.keywords[in]=${keyword}${bypassCacheParam}`
    return axios.get(url)
  },

  // Load page articles
  getBackgroundImage (pageId) {
    let bgUrl = `${baseEntryUrl}?include=5&limit=1&content_type=page&sys.id=${pageId}${bypassCacheParam}`

    return axios.get(bgUrl)
  },

  // Load page background for articles
  getPageArticles (pageId) {
    let articleUrl = `${baseEntryUrl}?include=5&content_type=page&order=-sys.createdAt&fields.navigationItem.sys.id=${pageId}${bypassCacheParam}`
    return axios.get(articleUrl)
  },

  searchNew (words, region) {
    let sysId = ''

    return this.getRegionId(region)
      .then((response) => {
        sysId = response.data.items[0].sys.id

        let searchUrl = `${baseSearchUrl}entries?content_type=article&fields.region.sys.id=${sysId}&query=${words}&limit=20&order=-sys.updatedAt${bypassCacheParam}`

        let token = ''
        let config = ''

        if (token) {
          config = {
            headers: {
              'X-Auth-Token': token
            }
          }
        }

        return axios.get(searchUrl, config)
      })
  },

  search (words) {
    let searchUrl = `${baseSearchUrl}entries?limit=20&content_type=article&query=${words}&order=-sys.updatedAt${bypassCacheParam}`
    let config = {
      headers: {
        'X-Auth-Token': localStorage.getItem('token')
      }
    }
    return axios.get(searchUrl, config)
  },

  // Load from latest articles != Landesverband
  loadTopArticlesFromRegions () {

    let articles = []

    let url = `${baseEntryUrl}?include=5&content_type=article&limit=4&order=-sys.createdAt&fields.region.sys.id[ne]=${baseContentfulRegionId}${bypassCacheParam}`

    axios.get(url).then(entries => {
      let regionArticles = this.parseArticles(entries.data);

      // Get articles details
      articles.push(regionArticles)
    }).catch((error) => {
      this.errorHandling(error, 'api.js -> loadTopArticlesFromRegions')
    })

    return articles
  },

  // Load All Pages DEPRECATED
  loadAllPages () {
    return axios.get(`${baseEntryUrl}?content_type=page&include=5`)
  },

  // Load All Articles
  loadAllArticles () {
    return axios.get(`${baseEntryUrl}?content_type=article&include=5&order=-sys.createdAt&limit=1000${bypassCacheParam}`)
  },

  // Load from latest articles != Landesverband
  loadArticle (id) {
    // console.log('loadArticle triggered')
    let article = []

    let url = `${baseEntryUrl}?include=5&limit=1&content_type=article&sys.id=${id}${bypassCacheParam}`
    // console.log('url: ', url)

    axios.get(url).then((entry) => {
      // console.log('entry: ', entry)

      // let assets = entry.data.includes.Asset
      // console.log('assets: ', assets)

      let post = this.parseArticles(entry.data)[0]
      // if (assets !== undefined) {
      //   post.assets = assets
      // }
      article.push(post)
      // console.log('post: ', post)

      const postId = post.id

      // console.log('postId: ', postId)

      // Get articles in localstorage
      let getStoredArticles = JSON.parse(localStorage.getItem(keyLastReadArticles))
      // console.log('getStoredArticles: ', getStoredArticles)

      let saveArticle = true
      if (getStoredArticles !== null) {
        for (let item of getStoredArticles) {
          let itemId = item.id
          if (itemId === postId) {
            saveArticle = false
          }
        }
      }
      // console.log('saveArticle: ', saveArticle)

      // Save to localstorage if article not yet included
      if (saveArticle) {
        if (getStoredArticles === null) {
          getStoredArticles = [post]
        } else {
          getStoredArticles.splice(0, 0, post)
        }

        localStorage.setItem(keyLastReadArticles, JSON.stringify(getStoredArticles.splice(0, 6)))
      }
    }).catch((error) => {
      this.errorHandling(error, 'api.js -> loadArticle')
    })

    return article
  },

  saveArticle (entry) {
    if (entry !== null) {
      this.loadArticle(entry.id)
    }
  },

  // Load an specific poll
  loadPoll (id) {
    // console.log('loadPoll triggered')
    let article = []
    let url = `${baseEntryUrl}?include=5&limit=1&content_type=poll&sys.id=${id}${bypassCacheParam}`
    // console.log('url: ', url)

    axios.get(url).then((entry) => {
      // console.log('entry: ', entry)
      const post = this.parseArticles(entry.data)[0]
      article.push(post)
    }).catch((error) => {
      this.errorHandling(error, 'api.js -> loadPoll')
    })
    // console.log('post: ', article)

    return article
  },

  loadPollData (id) {
    const db = Firebase.database()
    db.ref('/survey_results/' + id).once('value', (snapshot) => {
      const options = snapshot.val()

      return options
    })
  },

  // Load social media posts
  loadSocialPosts (windowWidth) {
    // console.log('loadSocialPosts triggered')

    // Set the amount of social items
    let amount = 5
    if (windowWidth >= 750) {
      amount = 5
    } else {
      amount = 20
    }

    // console.log('windowWidth: ', windowWidth);
    // console.log('amount: ', amount);

    let socialUrl = 'https://firestore.googleapis.com/v1beta1/projects/social-media-wall-bwf-data/databases/(default)/documents/tjlgzixcy46w/wuerttfv/posts?orderBy=order'

    return axios.get(socialUrl).catch(e => {
      this.errors.push(e)
    })
  },

  // Load All Articles
  loadAllPolls () {
    return axios.get(`${baseEntryUrl}?content_type=poll&include=5&order=-sys.createdAt&limit=1000${bypassCacheParam}`)
  },

  // Load all clubs
  getClubs () {
    let url = `${baseEntryUrl}?content_type=club&order=-sys.createdAt${bypassCacheParam}`
    return axios.get(url)
  },

  // Load all contests
  getContests () {
    let url = `${baseEntryUrl}?content_type=tournament&order=-sys.createdAt${bypassCacheParam}`
    return axios.get(url)
  },

  // Load all trainers
  getTrainers () {
    let url = `${baseEntryUrl}?content_type=trainer&order=-sys.createdAt`
    return axios.get(url)
  },

  // Load all shop products
  getShopProducts () {
    // let url = `${baseEntryUrl}?content_type=shopProduct&order=-sys.createdAt&fields.available=true${bypassCacheParam}`

    let url = `${baseEntryUrl}?content_type=shopProduct&order=fields.order&fields.available=true${bypassCacheParam}`

    return axios.get(url)
  },

  createEntry () {
    return client2.getSpace(spaces)
  },

  createMarketPlace (contentType, data) {
    let config = {
      headers: {
        'X-Contentful-Content-Type': contentType,
        'X-Auth-Token': localStorage.getItem('token')
      }
    }

    // console.log('config: ', config)
    // console.log('data: ', data)

    return axios.post(`${baseManageUrl}entries`, { fields: data }, config).then((data) => {
      // console.log('post data: ', data)

      let sys = data.data.sys
      config = {
        headers: {
          'X-Contentful-Version': sys.version,
          'X-Auth-Token':localStorage.getItem('token')
        }
      }
      axios.put(`${baseManageUrl}entries/${sys.id}/published`, null, config)
        .then(() => {
          // console.log('createMarketPlace success: ', contentType)
          EventBus.$emit(`create-entry-success`, contentType)
      })
        .catch((error) => {
          // console.log('createMarketPlace error: ', error)
          // console.log('createMarketPlace error contentType: ', contentType)
          EventBus.$emit(`create-entry-failed`, contentType)
        })
    })

  },

  initFirebase () {
    Firebase.initializeApp(firebaseConfig)
    firebase.auth().signInAnonymously().catch(function(error) {
      // Handle Errors here.
      let errorCode = error.code
      let errorMessage = error.message
      console.error(errorCode, errorMessage)
    })

    Firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        if (user.isAnonymous) {
          console.log('user.uid', user.uid)
          localStorage.setItem('userIdF', user.uid)
          localStorage.setItem('isAnonymousF', user.isAnonymous)
        }
      }
    })

    return Firebase
  },

  getToken () {
    let auth = Firebase.auth()
    auth.signInWithEmailAndPassword(firebaseLogin, firebasePassword).then((response) => {
        auth.currentUser.getIdToken(true).then(data => {
          localStorage.setItem('token', data)
        })
    })
  },

  sendEmail (postData) {
    let token = localStorage.getItem('token')

    axios.post(`${stanwoodUrl}mailgun`, postData,
      {
        headers: {
          'X-Auth-Token': token
        }
      })
      .then((response) => {
        localStorage.removeItem('wfv-shop')
        console.log('sendEmail', response)
      })
      .catch((error) => {
        console.error(error)
      })
  },

  parsePage (addons, response) {
    // console.log('API parsePage: ', addons, ' -> ' ,response)
    Utility.polyfill()

    let sectionTitle = {
      addons
    }

    // The current articles are linked in /items/fields/articles via sys.id in the path /includes/Entry
    let articles = []
    articles.push(JSON.parse(JSON.stringify(sectionTitle)))

    if (response.items.length > 0 && response.items[0].fields.hasOwnProperty('articles')) {
      let articleIds = response.items[0].fields.articles.map(function (obj) {
        return obj.sys.id
      });

      for (let i = 0; i < articleIds.length; i++) {
        let articleId = articleIds[i]
        let contentfulArticle = response.includes.Entry.find(function (obj) {
          if (obj.sys.id === articleId) {
            return obj
          }
        });

        if (!!contentfulArticle) {
          let article = initArticle(contentfulArticle, response)
          if (article.title && !article.hidden) {
            articles.push(article)
          }
        }
      }
    }

    return articles
  },

  parseArticles (response) {
    // console.log('API parseArticles response: ', response)
    let articles = []
    let items = response.items
    let itemCount = 0

    if (response.items !== undefined) {
      itemCount = response.items.length
    }

    for (let i = 0; i < itemCount; i++) {
      let contentfulArticle = items[i]
      let article = initArticle(contentfulArticle, response)
      // console.log('article: ', article)

      // console.log('article: ', article)

      if (article.title) {
        articles.push(article)
      }
    }

    // console.log('API parseArticles articles: ', articles)
    return articles;
  },

  parseNavigation (data) {
    // console.log('parseNavigation: ', data)
    let navigationItems = data.items[0].fields.navigationItems
    let entries = data.includes.Entry
    let errors = data.errors

    navigationItems.map((navigationItem) => {
      let detail = entries.filter((entry) => {
        return entry.sys.id === navigationItem.sys.id
      })
      if (detail.length > 0) {
        navigationItem.fields = {}
        navigationItem.fields = detail[0].fields
        navigationItem.expanded = false
        navigationItem.fields.title = detail.length > 0 ? detail[0].fields.title : ''
        navigationItem.navigationItems = detail[0].fields.navigationItems
        if (!!navigationItem.navigationItems && navigationItem.navigationItems.length > 0) {
          let tempNav = []
          navigationItem.navigationItems.forEach((nav) => {
            if (!!errors) {
              errors.map((error) => {
                if (error.details.id === nav.sys.id) {
                  let index = navigationItem.navigationItems.indexOf(nav)
                  tempNav.push(index)
                }
              })
            }
          })

          if (!!tempNav && tempNav.length > 0 && navigationItem.hasOwnProperty('navigationItems') && navigationItem.navigationItems.length > 0) {
            _.pullAt(navigationItem.navigationItems, tempNav)
          }

          navigationItem.navigationItems.map((navigationItem) => {
            let detail = entries.filter((entry) => {
              return entry.sys.id === navigationItem.sys.id
            })
            navigationItem.fields = {}
            navigationItem.fields = detail[0].fields
            navigationItem.fields.title = detail.length > 0 ? detail[0].fields.title : ''
          });
        }
      }
    })

    return navigationItems
  },

  foundPage (data, navId) {
    let pages = data.items
    let pageFound = null
    pages.map((page) => {
      if (!!page.fields.navigationItem) {
        if (page.fields.navigationItem.sys.id === navId) {
          pageFound = page
        }
      }
    })

    return pageFound

    // Resize Image
    resizeImage(asset, w=100, h=100)
    {
      if (!!asset && asset.fields.hasOwnProperty('file')) {
        return axios.get(`${asset.fields.file.url}?w=${w}&h=${h}${bypassCacheParam}`)
      }
      return null
    }
  },

  // Responsive Image
  responsiveImage (asset, w = 100, h = 100) {
    if (!!asset) {
      return `${asset}?w=${w}&h=${h}${bypassCacheParam}`
    }
  },

  getArticleImagesNew (id) {
    const bgUrl = `${baseAssetUrl}?include=5&limit=1&sys.id=${id}${bypassCacheParam}`

    // console.log('getArticleImages: ', bgUrl)
    axios.get(bgUrl).then((data) => {
      const res = data
      // console.log('res: ', res)
      return res
    })
  },

  // Error handling
  errorHandling (error, origin, redirect) {
    let eData = ''
    let eStatus = ''
    let eHeaders = ''
    let eRequest = ''
    let eMessage = ''
    let eConfig = ''
    let eOrigin = ''
    let redirectMe = false

    let stack = error.stack
    let message = error.toString()

    if(redirect)
      redirectMe = true

    if(origin) {
      eOrigin = `Error origin: ${origin}`
    }

    if (stack) {
      message += '\n' + stack
    }

    if (error.response) {
        eData = `Error data: ${error.response.data}`
        eStatus = `Error data: ${error.response.status}`
        eHeaders = `Error data: ${error.response.headers}`

        message += '\n' + eOrigin
        message += `\n${eData}`
        message += `\n${eStatus}`
        message += `\n${eHeaders}`

        console.log('error: ' , message)
    } else if (error.request) {
        // The request was made but no response was received
        eRequest = `Error data: ${error.request}`
        message += '\n' + eOrigin
        message += `\n The request was made but no response was received`
        message += `\n${eRequest}`
        console.log('error: ' , message)
    } else {
        // Something happened in setting up the request that triggered an Error
        eMessage = `Error data: ${error.message}`
        message += '\n' + eOrigin
        message += `\n Something happened in setting up the request that triggered an Error`
        message += `\n${eMessage}`
        console.log('error: ' , message)
    }

    if(error.config != undefined) {
      eConfig = `Error config: ${error.config}`
      message += '\n' + eOrigin
      message += `\n Config Error`
      message += `\n${eConfig}`
      console.log('error: ' , message)
    }

    // console.log('message: ', message)

    // send error as webhook to slack if not localhost
    // if(host.indexOf('localhost') >= 0) {
    //   let webhookUrl = 'https://hooks.slack.com/services/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'
    //
    //   const options = {
    //     text: message
    //   }
    //
    //   axios.post(webhookUrl, JSON.stringify(options))
    //     .then((response) => {
    //       // console.log('SUCCEEDED: Sent slack webhook: \n', response.data)
    //       resolve(response.data)
    //     })
    //     .catch((error) => {
    //       // console.log('FAILED: Send slack webhook', error)
    //       reject(new Error('FAILED: Send slack webhook'))
    //     })
    // }

    // redirect to 404 page
    if(redirectMe) {
      window.location.href = '/#/error/404'
    }
  }
}

// Init article
let initArticle = (contentfulArticle, response) => {
  // console.log('contentfulArticle: ', contentfulArticle);
  // console.log('response: ', response);
  // console.log('API contentfulArticle: ', response)

  // check for imagestext
  let imagesText = contentfulArticle.fields.imagesText
  if (imagesText !== undefined) {
    if (Object.values(imagesText)[0] === '') {
      imagesText = undefined
    }
  }
  // console.log('imagesText: ', imagesText)

  let article = {
    "id": contentfulArticle.sys.id,
    "hidden": !!contentfulArticle.fields.hidden ? true : false,
    "unique": uniqueId(25), // needed for UX stuff
    "pagetitle": contentfulArticle.fields.hasOwnProperty('pageTitle') ? contentfulArticle.fields.pageTitle : '',
    "title": contentfulArticle.fields.title,
    "date": contentfulArticle.sys.createdAt,
    "orientation": contentfulArticle.fields.imagesOrientation,
    "imagestext": imagesText,
    "type": 'article'
  }

  // console.log('article: ', article);

  if (!!contentfulArticle.fields.question) {
    article.title = contentfulArticle.fields.question
    article.question = contentfulArticle.fields.question
    article.options = contentfulArticle.fields.options
    article.type = 'poll'
  }

  if (!!contentfulArticle.fields.text) {
    article.text = contentfulArticle.fields.text
  }

  // The current images are linked via sys.id in the path /includes/Asset
  if (contentfulArticle.fields.images) {
    // console.log('contentfulArticle.fields.images: ', contentfulArticle.fields.images)
    let images = []
    for (let i = 0; i < contentfulArticle.fields.images.length; i++) {
      let img = contentfulArticle.fields.images[i]

      for (let y = 0; y < response.includes.Asset.length; y++) {
        let asst = response.includes.Asset[y]
        if (asst.sys.id === img.sys.id) {
          // console.log('asst: ', asst)

          // Here we build our image object that we ship to the frontend
          let imgc = {}
          let imageId = asst.sys.id
          let orientationObject = contentfulArticle.fields.imagesOrientation
          let orientation = 'top'

          // console.log('id: ', imageId)
          // console.log('orientationObject: ', orientationObject)

          if(orientationObject) {
            orientation = orientationObject[imageId]
            if (orientation === 'horizontal') {
              orientation = 'middle'
            }
          }
          // console.log('orientation: ', orientation)

          imgc.id = imageId
          imgc.counter = i
          imgc.url = asst.fields.file.url
          imgc.caption = asst.fields.title
          if(asst.fields.file.details.image) {
            imgc.width = asst.fields.file.details.image.width
            imgc.height = asst.fields.file.details.image.height
          } else {
            imgc.width = 100
            imgc.height = 100
          }
          if(asst.fields.file.details) {
            imgc.size = asst.fields.file.details.size
          } else {
            imgc.size = 0
          }
          imgc.description = asst.fields.hasOwnProperty('description') ? asst.fields.description : ''
          imgc.orientation = orientation

          images.push({imgc: imgc})
        }
      }
    }
    // console.log('images: ', images)
    // Push the images array to the data
    article.images = images
  }

  // console.log('article: ', article);
  return article
}

let getArticleImages = (id) => {
  let bgUrl = `${baseAssetUrl}?include=5&limit=1&sys.id=${id}${bypassCacheParam}`

  // console.log('getArticleImages: ', bgUrl)
  axios.get(bgUrl)
    .then(entries => {
      if(entries.data.items.length > 0) {
        let imageURL = entries.data.items[0].fields.file.url
        // console.log('imageURL: ', imageURL)

        return imageURL
      }
    })
    .catch((error) => {
      // this.error = true
      // console.log(error)
      api.errorHandling(error, `Article.vue (getImage) @ ${window.location.href}`)
    })
}

// Create unique ID
let uniqueId = (len) => {
  const charset = "abcdefghijklmnopqrstuvwxyz0123456789#*@?!§"
  let text = ''

  for(let i=0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length))

  return text
}



// WEBPACK FOOTER //
// ./src/api.js